/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getValuationsStatuses = ({ params } = {}) => axios.get(`valuation_statuses`, { params });